import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PatientModel } from '../models/PatientsModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class PatientsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getPatients(patientCode: string, patientFName: string, telMobile: string, compCode: string) {
        let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("patientFName", patientFName);
        params = params.append("telMobile", telMobile);
        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<PatientModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Patients/PatientLookup', options);
    }

    public getPatientsTop(compCode: string) {
        let params = new HttpParams();
        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<PatientModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Patients/PatientLookupTop', options);
    }
}
